var React = require('react');

function FacebookPrimary4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M255.995 0C114.614 0 0 114.672 0 256.125C0 376.237 82.6556 477.027 194.157 504.709V334.396H141.371V256.125H194.157V222.398C194.157 135.224 233.59 94.8174 319.133 94.8174C335.353 94.8174 363.339 98.0036 374.787 101.18V172.126C368.745 171.491 358.249 171.173 345.214 171.173C303.241 171.173 287.021 187.084 287.021 228.443V256.125H370.64L356.273 334.396H287.021V510.375C413.78 495.058 512 387.076 512 256.125C511.99 114.672 397.376 0 255.995 0Z","fill":"#0E774A"}));
}

FacebookPrimary4.defaultProps = {"width":"512","height":"510","viewBox":"0 0 512 510","fill":"none"};

module.exports = FacebookPrimary4;

FacebookPrimary4.default = FacebookPrimary4;
